<app-document-subheader></app-document-subheader>
<div class="details-content container-fluid h-100">
  <div class="row h-100">
    <div class="col-content d-flex flex-column h-100">
      @if (this.bankBase$ | async; as bank) {
        <div class="page-container">
          <div class="card card-light w-100">
            <div class="card-body">
              <div class="container-fluid">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label class="form-title-label" translate
                        >CONTACT_LBL_NAME</label
                        >
                        <div class="form-title">{{ bank.name }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6 col-lg-6">
                      <div class="form-group row">
                        <label class="col-4 col-form-label-sm" translate
                          >BANK_LBL_BIC</label
                          >
                          <div class="col">
                            <span class="form-control-plaintext form-control-sm">
                              {{ bank.bic }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 col-lg-6">
                        <div class="form-group row">
                          <label class="col-4 col-form-label-sm" translate
                            >CONTACT_LBL_ADDRESS</label
                            >
                            <div class="col">
                              <div
                                class="form-control-plaintext form-control-sm mb-2 h-100 p-0"
                                >
                                <app-address
                                  [address]="bank.address"
                                  [zipCode]="bank.zipCode"
                                  [city]="bank.city"
                                  [country]="bank.countryName"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col">
                            <div class="form-group row">
                              <label class="col-4 col-form-label-sm" translate
                                >CONTACT_LBL_PHONE_NUMBER</label
                                >
                                <div class="col">
                                  <span class="form-control-plaintext form-control-sm">
                                    <app-phone-number
                                      [phoneNumber]="bank.phoneNumber"
                                      [isLinkEnabled]="true"
                                    ></app-phone-number>
                                  </span>
                                </div>
                              </div>
                              <div class="form-group row">
                                <label class="col-4 col-form-label-sm" translate
                                  >CONTACT_LBL_EMAIL</label
                                  >
                                  <div class="col">
                                    <span class="form-control-plaintext form-control-sm">
                                      <a href="mailto:{{ bank.email }}">{{ bank.email }}</a>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                @if (this.bankBase$ | async; as bank) {
                  <div class="col-comment">
                    <app-comment-panel
                      [entityType]="'Bank'"
                      [entityId]="bank.id.toString()"
                    ></app-comment-panel>
                  </div>
                }
              </div>
            </div>
